import { useState, useEffect } from "react";
import { ParserConfigDto } from "../../types";
import { getParserConfigById } from "../../services/parserConfigService";

export const useParserConfigDetail = (parserConfigId: string | null) => {
  const [selectedRow, setSelectedRow] = useState<ParserConfigDto>();
  const [loading, setLoading] = useState(false);

  const getParserConfig = async (id: string) => {
    try {
      setLoading(true);
      const response = await getParserConfigById(id);
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      setSelectedRow(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  useEffect(() => {
    if (parserConfigId) {
      getParserConfig(parserConfigId);
    }
  }, [parserConfigId]);

  return {
    selectedRow,
    loading,
    getParserConfig,
  };
};
